import { MapPin } from "@phosphor-icons/react";

export default function MeetDialog({ meet, distance, onAccept, onDecline }) {
  if (!meet) return null;
  return (
    <div className="fixed inset-0 z-[70] flex items-end justify-center bg-black/50 px-3 pb-24 sm:items-center sm:pb-0" data-testid="meet-dialog">
      <div className="w-full max-w-sm border-2 border-black bg-white p-5 shadow-[8px_8px_0px_rgba(0,0,0,1)]">
        <div className="mb-3 inline-flex items-center gap-2 border-2 border-black bg-accent px-3 py-1 text-white shadow-[3px_3px_0px_rgba(0,0,0,1)]">
          <MapPin weight="fill" size={16} />
          <span className="font-mono2 text-xs font-bold uppercase tracking-widest">Meet Request</span>
        </div>
        <h2 className="font-heading text-2xl font-black uppercase leading-none tracking-tight">
          {meet.created_by_name || "Someone"} wants to meet at {meet.label || "a spot"}
        </h2>
        <p className="mt-2 font-mono2 text-sm font-medium text-black/60">
          {distance != null ? `It's about ${distance} from you. ` : ""}Are you heading over?
        </p>
        <div className="mt-5 flex gap-3">
          <button
            data-testid="meet-decline-button"
            onClick={onDecline}
            className="h-14 flex-1 border-2 border-black bg-white font-heading text-base font-bold uppercase shadow-[3px_3px_0px_rgba(0,0,0,1)] active:translate-x-[3px] active:translate-y-[3px] active:shadow-none"
          >
            Not now
          </button>
          <button
            data-testid="meet-accept-button"
            onClick={onAccept}
            className="h-14 flex-1 border-2 border-black bg-primary font-heading text-base font-bold uppercase shadow-[3px_3px_0px_rgba(0,0,0,1)] active:translate-x-[3px] active:translate-y-[3px] active:shadow-none"
          >
            I'm coming
          </button>
        </div>
      </div>
    </div>
  );
}
